import Colors from '../../../../shared/assets/style/default/color';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const PlayerLanguageModalContainer = styled.div<{ hideBackground?: boolean }>`
  background: ${(props) =>
    props.hideBackground ? '' : Colors['modal']['background']};
  display: flex;
  height: 100vh;
  left: ${148 * Screen.widthRatio}px;
  position: fixed;
  top: 0;
  width: ${600 * Screen.widthRatio}px;
  z-index: 1;
`;

export default PlayerLanguageModalContainer;
